
<template>
    <div>
      <div>
        <LoaderTuin :is-loading="loader" />
      </div>
      <div
        v-if="!sloader"
        class="card"
      >      
        <div class="flex">
          <ToastAlert
            :is-active="toastAlert"
            :type="typeMsg"
            :message="msg"
          />
        </div>
  
        <div class="flex w-full justify-end items-end mt-5 mb-5">
          <fwb-tooltip>
            <template #trigger>
              <fwb-toggle
                v-model="is_available"
                label="Disponible"
                :disabled="!complete_property"
              />
            </template>
            <template #content>
              <div v-show="complete_property">
                Activa tu propiedad para que sea visible en el Tuin
              </div>
              <div v-show="!complete_property">
                Aún te faltan algunos datos para poder hacer visible tu propiedad
              </div>
            </template>
          </fwb-tooltip>
        </div>
  
        <Accordion value="0">
          <AccordionPanel value="0">
            <AccordionHeader
              class="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 rounded-t-xl focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
              data-accordion-target="#accordion-collapse-body-1"
              aria-expanded="true"
              aria-controls="accordion-collapse-body-1"
            >
              <button type="button">
                <div class="flex float-left">
                  <img
                    v-if="is_complete_gral"
                    src="@/assets/imgs/icons/circle_ok.png"
                    alt="tuin form complete"
                    width="25"
                  >
  
                  <img
                    v-if="!is_complete_gral"
                    src="@/assets/imgs/icons/circle_disabled.png"
                    alt="tuin form complete"
                    width="25"
                  >
                </div>
                <div class="flex float-left ml-2">
                  Información gen
                </div>
              </button>
            </AccordionHeader>
            <AccordionContent>
              <div class="border">
                <FormGeneralComponent 
                  :resp="data_property.general" 
                  :property-id="props.propertyId"
                  @trigger-update="retriveProperty"  
                />
              </div>
            </AccordionContent>
          </AccordionPanel>
  
          <!-- :disabled="!is_complete_location"   -->
          <AccordionPanel 
            value="1"
            :disabled="!is_complete_gral"
          >
            <!-- :class="{ 'bg-gray-300': !is_complete_location, 'border-gray-200': is_complete_location }" -->
            <AccordionHeader
              class="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
              data-accordion-target="#accordion-open-body-2"
              aria-expanded="false"
              aria-controls="accordion-open-body-2"
            >
              <button type="button">
                <div class="flex float-left">
                  <img
                    v-if="is_complete_location"
                    src="@/assets/imgs/icons/circle_ok.png"
                    alt="tuin form complete"
                    width="25"
                  >
                  <img
                    v-if="!is_complete_location"
                    src="@/assets/imgs/icons/circle_disabled.png"
                    alt="tuin form complete"
                    width="25"
                  >
                </div>
                <div class="flex float-left ml-2">
                  Ubicación
                  <span v-show="!is_complete_gral">
                    (Debe ingresar los datos de información general para continuar )
                  </span>
                </div>
              </button>
            </AccordionHeader>
            <AccordionContent>
              <div class="border">
                <FormLocationComponent  
                  :resp="data_property" 
                  :property-id="props.propertyId"
                  @trigger-update="retriveProperty"  
                />
              </div>
            </AccordionContent>
          </AccordionPanel>
  
          <!-- :disabled="!is_complete_characters"  -->
          <AccordionPanel 
            value="2" 
            :disabled="!is_complete_location"
          >
            <!-- :class="{ 'bg-gray-300': !is_complete_characters, 'border-gray-200': is_complete_characters }" -->
            <AccordionHeader
              class="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <button type="button">
                <div class="flex float-left">
                  <img
                    v-if="is_complete_characters"
                    src="@/assets/imgs/icons/circle_ok.png"
                    alt="tuin form complete"
                    width="25"
                  >
  
                  <img
                    v-if="!is_complete_characters"
                    src="@/assets/imgs/icons/circle_disabled.png"
                    alt="tuin form complete"
                    width="25"
                  >
                </div>
                <div class="flex float-left ml-2">
                  Características 
                  <span 
                    v-show="!is_complete_location"
                    class=" text-sm font-bold text-slate-900 pl-2"
                  >
                    (Debe ingresar los datos de ubicación general para continuar)
                  </span>
                </div>
              </button>
            </AccordionHeader>
            <AccordionContent>
              <div class="border">
                <FormCharactersComponent 
                  :resp="data_property" 
                  :property-id="props.propertyId"
                  @trigger-update="retriveProperty"  
                />
              </div>
            </AccordionContent>
          </AccordionPanel>
        </Accordion>
      </div>
    </div>
  </template>
  
  <script setup>
  import Accordion from "primevue/accordion";
  import AccordionPanel from "primevue/accordionpanel";
  import AccordionHeader from "primevue/accordionheader";
  import AccordionContent from "primevue/accordioncontent";
  import ToastAlert from "@/commond/ToastAlert.vue";
  import FormGeneralComponent from "@/components/properties/FormGeneralComponent.vue";
  import FormLocationComponent from "@/components/properties/FormLocationComponent.vue";
  import FormCharactersComponent from "@/components/properties/FormCharactersComponent.vue";
  import axios from "axios";
  import { FwbToggle, FwbTooltip } from "flowbite-vue";
  import LoaderTuin from "@/commond/LoaderTuin.vue";
  import { ref, onMounted, computed } from "vue";
  import { useStore } from "vuex";
  let store = useStore();
  let session = computed(() => store.getters.getUserSession);
  
  const props = defineProps({
    propertyId: {
      type: Number,
      default: 0
    }
  });
  
  
  
  //const available         = ref(1);
  let loader = ref(false);
  let is_complete_gral = ref(false);
  let is_complete_location = ref(false);
  let is_complete_characters = ref(false);
  let data_property = ref({});
  
  //Este botón cambia el estatus de la propiedad para que sea visible en tuin
  let is_available = ref(false);
  
  // Este campo valida si ya guardo la info necesaria para activar el botónde activar propiedad
  let complete_property = ref(false);
  let property_id = ref(0);
  // Definimos la variable reactiva que controla la visibilidad de la modal.
  
  let toastAlert = ref(false);
  let typeMsg = ref("");
  let msg = ref("");
  
  async function getProperty() {
    loader.value = true;
    let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${property_id.value}`;
  
    var options = {
      headers: {
        "Content-Type": "application/json", // Es importante establecer el tipo de contenido para el envío de archivos
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };
  
    axios
      .get(url_cnn, options)
      .then((response) => {
        var resp = response.data.resp;     
        is_complete_gral.value = resp.fn_validation_gral;
        is_complete_location.value = resp.fn_validation_location;
        is_complete_characters.value = resp.fn_validation_characters;
        data_property.value = resp;
        loader.value = false;
      })
      .catch((error) => {
        console.log("[ERROR]", error.response);
        loader.value = false;
      });
  }
  
  
  onMounted(async () => {
    if (props.propertyId != 0) {
      property_id.value = props.propertyId;
      await getProperty();
    }
  });
  
  async function retriveProperty(propertyId){
    property_id.value = propertyId;
    await getProperty();
  }
  </script>
  
  